export const Statistics = [
    {
        type: "Animal Ag. Statistics",
        name: "Animal agriculture is the leading cause of species extinction, ocean dead zones, water pollution, and habitat destruction.",
        category: "",
        author: "",
        description: "",
        link: "https://youaretheirvoice.com/pages/the-daunting-facts",
        "": "",
    },
    {
        type: "Animal Ag. Statistics",
        name: "Livestock covers 45% of the earth’s total land.",
        category: "",
        author: "",
        description: "",
        link: "https://cgspace.cgiar.org/bitstream/handle/10568/10601/IssueBrief3.pdf",
        "": "",
    },
    {
        type: "Animal Ag. Statistics",
        name: "51% of greenhouse gas emissions are due to livestocks and their byproducts.",
        category: "",
        author: "",
        description: "",
        link: "http://shrinkthatfootprint.com/food-carbon-footprint-diet",
        "": "",
    },
    {
        type: "Animal Ag. Statistics",
        name: "90 million tons of fish are pulled from the oceans each year.",
        category: "",
        author: "",
        description: "",
        link: "https://www.nationalgeographic.com/environment/oceans/critical-issues-overfishing/",
        "": "",
    },
    {
        type: "Animal Ag. Statistics",
        name: "2,500 gallons of water are needed to produce 1 pound of beef.",
        category: "",
        author: "",
        description: "",
        link: "https://www.cowspiracy.com/facts/",
        "": "",
    },
    {
        type: "Animal Ag. Statistics",
        name: "Livestock is responsible for 60% of Nitrous Oxide emissions (296x more destructive than cO2)",
        category: "",
        author: "",
        description: "",
        link: "http://www.fao.org/3/a0701e/a0701e00.htm https://www.eia.gov/environment/emissions/ghg_report/ghg_nitrous.php",
        "": "",
    },
    {
        type: "Animal Ag. Statistics",
        name: "A person who follows a vegan diet produces the equivalent of 50% less carbon dioxide.",
        category: "",
        author: "",
        description: "",
        link: "https://link.springer.com/article/10.1007%2Fs10584-014-1169-1",
        "": "",
    },
    {
        type: "Animal Ag. Statistics",
        name: "Every minute, 7 million pounds of excrement are produced by animals raised for food in the US",
        category: "",
        author: "",
        description: "",
        link: "https://www.nrcs.usda.gov/wps/portal/nrcs/detail/null/?cid=nrcs143_014211 https://directives.sc.egov.usda.gov/viewerFS.aspx?hid=21430 https://directives.sc.egov.usda.gov/OpenNonWebContent.aspx?content=31475.wba",
        "": "",
    },
    {
        type: "Animal Ag. Statistics",
        name: "Up to 137 species are lost every day from rainforest destruction.",
        category: "",
        author: "",
        description: "",
        link: "https://msu.edu/~urquhart/professional/NASA-Deforestation.pdf",
        "": "",
    },
    {
        type: "Animal Ag. Statistics",
        name: "1 to 1.5 acres rainforest are cleared every second",
        category: "",
        author: "",
        description: "",
        link: "http://www.savetheamazon.org/rainforeststats.htm",
        "": "",
    },
    {
        type: "Animal Ag. Statistics",
        name: "Animal agriculture is responsible for 91% of amazon destruction",
        category: "",
        author: "",
        description: "",
        link: "https://openknowledge.worldbank.org/bitstream/handle/10986/15060/277150PAPER0wbwp0no1022.pdf?sequence=1",
        "": "",
    },
    {
        type: "Animal Ag. Statistics",
        name: "We could see fishless oceans by 2048.",
        category: "",
        author: "",
        description: "",
        link: "https://cdn.ioos.noaa.gov/media/2017/12/worm-et-al.pdf https://www.nationalgeographic.com/animals/2006/11/seafood-biodiversity/",
        "": "",
    },
    {
        type: "Animal Ag. Statistics",
        name: "For 1 pound of fish, up to 5 pounds of unintended species are caught.",
        category: "",
        author: "",
        description: "",
        link: "http://www.fao.org/3/W6602E/w6602E09.htm",
        "": "",
    },
    {
        type: "Animal Ag. Statistics",
        name: "80% of antibiotic sold in the US are for livestock.",
        category: "",
        author: "",
        description: "",
        link: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4638249/",
        "": "",
    },
    {
        type: "Animal Ag. Statistics",
        name: "Around 9 billion land animals are killed each year in the U.S. alone to produce meat, dairy, and eggs. That’s about one million every hour.",
        category: "",
        author: "",
        description: "",
        link: "https://awellfedworld.org/factory-farms/",
        "": "",
    },
    {
        type: "Animal Ag. Statistics",
        name: "We are currently growing enough food to feed 10 billion people.",
        category: "",
        author: "",
        description: "",
        link: "https://www.commondreams.org/views/2012/05/08/we-already-grow-enough-food-10-billion-people-and-still-cant-end-hunger",
        "": "",
    },
    {
        type: "Animal Ag. Statistics",
        name: "82% of starving children live in countries where food is fed to animals, and eaten by other countries",
        category: "",
        author: "",
        description: "",
        link: "http://comfortablyunaware.com/blog/the-world-hunger-food-choice-connection-a-summary/",
        "": "",
    },
    {
        type: "Animal Ag. Statistics",
        name: "As many as 650,000 whales, dolphins and seals are killed every year.",
        category: "",
        author: "",
        description: "",
        link: "https://www.theguardian.com/environment/2014/mar/20/americas-nine-most-wasteful-fisheries-named https://oceana.org/sites/default/files/reports/Bycatch_Report_FINAL.pdf",
        "": "",
    },
    {
        type: "Animal Ag. Statistics",
        name: "Greenhouse gas emissions across the supply chain",
        category: "",
        author: "",
        description: "",
        link: "https://ourworldindata.org/grapher/food-emissions-supply-chain",
        "": "",
    },
    {
        type: "Animal Ag. Statistics",
        name: "1,000 gallons of water are required to produce 1 gallon of milk.",
        category: "",
        author: "",
        description: "",
        link: "https://waterfootprint.org/media/downloads/Hoekstra-2008-WaterfootprintFood.pdf https://waterfootprint.org/media/downloads/Mekonnen-Hoekstra-2012-WaterFootprintFarmAnimalProducts_1.pdf",
        "": "",
    },
]
